// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const linkingSections: PaneSection[] = [
  {
    section: 'overview',
    title: 'Linked devices',
    body: 'This is where you connect another phone, tablet, or computer to your account. Pairing stays end to end encrypted the whole way through.',
  },
  {
    section: 'link-device',
    title: 'Link a new device',
    body: 'Open Ping on the new device and point its camera at the code here to pair it. If the camera will not cooperate, you can paste the details in by hand instead.',
  },
  {
    section: 'redeem',
    title: 'Redeem a pairing code',
    body: 'On the device you are setting up, scan the pairing code shown on your other device. You can also paste the code in if scanning is not an option.',
  },
];
